import * as React from "react";
import Consumer from "../models/Consumer";
import BaseDialog, { Field } from "./BaseDialog";
import type Room from "../models/Room";

import Logger from "../Logger";

const logger = new Logger();

export default function ConsumerDialog(props: { parentRoom?: Room; obj?: Consumer }) {
  const { parentRoom, obj } = props;

  const [tag, setTag] = React.useState(obj?.tag || state.nameAndTagManager.generateTag(new Consumer({}, parentRoom)));
  const [name, setName] = React.useState(obj?.name || "");

  const edit = obj != undefined;
  var newTag = tag;
  var newName = name;

  if (!edit && parent == undefined) {
    logger.error("parent == undefined");
  }

  function getConsumerType(): string {
    if (obj) {
      if (obj.image) {
        if (obj.image.substring(17).replace(".png", "") == "dimmer") {
          return state.translate("channelType.Dimmer", "Dimmer");
        } else if (obj.image.substring(17).replace(".png", "") == "tuneable-white-2") {
          return state.translate("channelType.TuneableWhite", "Tunable White");
        } else if (obj.image.substring(17).replace(".png", "") == "onoff") {
          return state.translate("channelType.Switch", "Schalter");
        } else if (obj.image.substring(17).replace(".png", "") == "shutter") {
          return state.translate("channelType.Jalousie", "Jalousie");
        } else if (obj.image.substring(17).replace(".png", "") == "jalousie") {
          return state.translate("channelType.Blind", "Rollladen");
        } else if (obj.image.substring(17).replace(".png", "") == "heating") {
          return state.translate("channelType.Dimmer", "Heizung");
        }
        //  else if (obj.image.substring(17).replace(".png", "") == "touch-6") {
        //   returnstate.translate("Taster");
        // }
      }
    }

    return "consumer"; // no itx
  }

  function validName(name1: string): boolean {
    parentRoom?.consumers.forEach((obj) => {
      if (obj.name == name1) {
        return false;
      }
    });
    return true;
  }
  function validTag(tag1: string): boolean {
    parentRoom?.consumers.forEach((obj) => {
      if (obj.tag == tag1) {
        return false;
      }
    });
    return true;
  }
  return (
    <BaseDialog
      title={
        edit
          ? state.translate("consumerDialog.renameT1", `Benenne T1`, { T1: getConsumerType() })
          : state.translate("consumerDialog.createNewConsumer", "Create new Consumer")
      }
      // onClose={() => {
      //     return true
      // }}

      onOk={() => {
        if (edit) {
          if (obj) {
            obj.name = name;
            obj.tag = tag;
            obj.raiseOnChange();
          }
        } else {
          const newConsumer = new Consumer({ name: name, tag: tag }, parentRoom);
          parentRoom?.addConsumer(newConsumer);
        }
        return true;
      }}
    >
      <Field label={state.translate("tag", "Tag")}>
        <input
          className="input"
          maxLength={state.maxCharLimit.tag}
          defaultValue={tag}
          onChange={(ev) => {
            const v = ev.target.value.toLocaleUpperCase().trim();
            ev.target.value = v;
            newTag = v;
          }}
          onBlur={(ev) => {
            if (validTag(newTag)) {
              setTag(newTag);
            } else {
              alert(
                state.translate(
                  "consumerDialog.C1T1K1isAlreadyUsedAndWillBeResetToT2",
                  `C1- K1 T1 ist bereits vergeben und wird auf T2 zurückgesetzt`,
                  {
                    T1: ev.target.innerText,
                    C1: getConsumerType(),

                    T2: tag,
                    K1: state.translate("tag", "Tag"),
                  },
                ),
              );
              ev.target.innerText = tag;
              newTag = tag;
            }
          }}
        ></input>
      </Field>
      <Field label={`${getConsumerType()}-${state.translate("name", "Name")}`}>
        <input
          className="input"
          maxLength={state.maxCharLimit.text}
          defaultValue={name}
          onChange={(ev) => {
            newName = ev.target.innerText;
          }}
          onBlur={(ev) => {
            if (validName(newName)) {
              setName(newName);
            } else {
              alert(
                state.translate(
                  "consumerDialog.C1T1K1isAlreadyUsedAndWillBeResetToT2",
                  `C1- K1 T1 ist bereits vergeben und wird auf T2 zurückgesetzt`,
                  {
                    C1: getConsumerType(),
                    T1: ev.target.innerText,
                    T2: tag,
                    K1: state.translate("name", "Name"),
                  },
                ),
              );

              ev.target.innerText = name;
              newName = name;
            }
          }}
        ></input>
      </Field>

      <Field label={state.translate("components.Channel", "Kanal")}>
        <div>{obj?.getConnectedChannel()?.fullTag}</div>
      </Field>
    </BaseDialog>
  );
}
